import Alert from 'common/components/alert/Alert';
import Modal from 'common/components/modal/Modal';
import { IPagination } from 'common/components/pagination/Pagination';
import AlertType from 'common/types/AlertType';
import { License } from 'domain/types/License';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import VacationRentalForm from './VacationRentalForm';
import { VacationRentalRequest } from './VacationRentalRequest';
import VacationRentalTable from './VacationRentalTable';

export interface IVacationRentalPresenter {
  onSubmit: (values: VacationRentalRequest) => void;
  saving: boolean;
  success: boolean;
  errors: string[] | null;
  pagination: IPagination;
  data: License[];
  onPageChange: (page: number) => void;
}
const VacationRentalPresenter = (props: IVacationRentalPresenter) => {
  const [modalOpen, setModalOpen] = useState(false);

  const info = (
    <>
      <h3>Vacation Rentals / Bed & Breakfast</h3>
      <p>
        A “Vacation Rental” is a dwelling unit that is rented to guests. A “Bed
        & Breakfast Establishment” is an owner-occupied residential building in
        which 11 or fewer rooms are rented to guests. Both Vacation Rentals and
        Bed & Breakfast Establishments must obtain a license from the City.
        Vacation Rentals must apply and collect hotel accommodation tax and
        submit it to the City themselves. Vacation Rentals and Bed & Breakfast
        Establishments may advertise or list their rentals through a Short-Term
        Residential Advertising Platform.
      </p>
    </>
  );

  const error = props.errors && (
    <Alert type={AlertType.danger}>
      <ul>
        {props.errors.map((e) => (
          <li key={e}>{e}</li>
        ))}
      </ul>
    </Alert>
  );

  const success = props.success && (
    <Alert type={AlertType.success}>
      {`Vacation rental / bed & breakfast license has been added.`}
    </Alert>
  );

  if (props.data.length > 0) {
    return (
      <>
        {info}
        <Button
          type='button'
          variant='primary'
          className='mb-3'
          onClick={() => setModalOpen(true)}
        >
          Add another License
        </Button>
        <VacationRentalTable
          data={props.data}
          pagination={{
            totalPages: props.pagination.totalPages,
            totalCount: props.pagination.totalCount,
            currentPage: props.pagination.currentPage,
            itemsPerPage: props.pagination.itemsPerPage,
            onPageChange: props.onPageChange,
          }}
        />

        <Modal
          title='Add License'
          body={
            <div className='p-3'>
              {error}
              {success}
              <VacationRentalForm {...props} />
            </div>
          }
          show={modalOpen}
          toggle={() => setModalOpen((prev) => !prev)}
        />
      </>
    );
  }

  return (
    <>
      {info}
      {error}
      {success}
      <VacationRentalForm {...props} />
    </>
  );
};
export default VacationRentalPresenter;
